'use strict';

var motionValue = require('../interfaces/motion-value.cjs');
var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');
var index = require('../../../../../../../motion-dom/dist/es/value/index.cjs');

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue.isMotionValue(value) ? value : index.motionValue(value);
    motionValue$1.start(motionValue.animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

exports.animateSingleValue = animateSingleValue;
//# sourceMappingURL=single-value.cjs.map
